import { DocumentNode } from 'graphql';

export function getQueryName(document: DocumentNode): string {
  return (document.definitions[0] as any).name.value;
}
